import React, { useState } from 'react';
import {
  Button,
  TextField,
  Typography,
  InputAdornment,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Link } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { useBrandOutlinedFieldStyles } from './brandOutlinedFieldStyles';

const useStyles = makeStyles((theme) => ({
  urlFieldWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  rotatedIcon: {
    transform: 'rotate(-45deg)',
  },
}));

const BrandUrlField = ({ url, onUrlChange, isEditMode }) => {
  const classes = useStyles();
  const fieldClasses = useBrandOutlinedFieldStyles();

  const [isUrlEditable, setIsUrlEditable] = useState(false);

  const handleEditUrlClick = () => {
    setIsUrlEditable(true);
  };

  /** In create flow the field is read-only until "Modifica URL"; in edit mode it stays editable like the name field. */
  const urlReadOnly = !isEditMode && !isUrlEditable;

  return (
    <div>
      {isEditMode ? (
        <Typography>URL del brand</Typography>
      ) : (
        <Typography>La tua URL sarà:</Typography>
      )}
      <div className={classes.urlFieldWrapper}>
        <TextField
          className={`${fieldClasses.outlinedField}${
            urlReadOnly ? ` ${fieldClasses.outlinedFieldLocked}` : ''
          }`}
          variant="outlined"
          value={url}
          onChange={onUrlChange}
          onBlur={() => {
            if (!isEditMode) {
              setIsUrlEditable(false);
            }
          }}
          inputProps={{
            readOnly: urlReadOnly,
            tabIndex: urlReadOnly ? -1 : undefined,
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Link className={classes.rotatedIcon} />
              </InputAdornment>
            ),
          }}
        />
        {!isEditMode && (
          <Button
            disabled={isUrlEditable}
            variant="contained"
            onClick={handleEditUrlClick}
          >
            Modifica URL
          </Button>
        )}
      </div>
    </div>
  );
};

BrandUrlField.propTypes = {
  url: PropTypes.string.isRequired,
  onUrlChange: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool.isRequired,
};

export default BrandUrlField;
